import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.to-fixed.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "calculator"
};
var _hoisted_2 = {
  class: ""
};
var _hoisted_3 = {
  class: "input-screen"
};
var _hoisted_4 = {
  class: "calculator-buttons-wrapper"
};
var _hoisted_5 = {
  class: "d-flex flex-row fl-ev"
};
var _hoisted_6 = {
  class: "d-flex flex-row fl-ev"
};
var _hoisted_7 = {
  class: "d-flex flex-row fl-ev"
};
var _hoisted_8 = {
  class: "d-flex flex-row fl-ev"
};
var _hoisted_9 = {
  class: "d-flex flex-row fl-ev"
};

var _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, "CASH", -1);

var _hoisted_11 = {
  class: "d-flex flex-row fl-s-a calculator-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_button = _resolveComponent("el-button");

  var _component_el_dialog = _resolveComponent("el-dialog");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
    modelValue: _ctx.dialogVisible,
    "onUpdate:modelValue": _cache[16] || (_cache[16] = function ($event) {
      return _ctx.dialogVisible = $event;
    }),
    title: "Enter a number",
    "close-on-click-modal": false,
    "close-on-press-escape": false,
    "show-close": false
  }, {
    footer: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_11, [_createVNode(_component_el_button, {
        class: "cancel",
        onClick: _cache[14] || (_cache[14] = function ($event) {
          return _ctx.cancel();
        })
      }, {
        default: _withCtx(function () {
          return [_createTextVNode("Cancel")];
        }),
        _: 1
      }), _createVNode(_component_el_button, {
        type: "primary",
        class: "confirm",
        onClick: _cache[15] || (_cache[15] = function ($event) {
          return _ctx.$emit('confirmNumber', Number(_ctx.inputContent));
        })
      }, {
        default: _withCtx(function () {
          return [_createTextVNode("Confirm")];
        }),
        _: 1
      })])];
    }),
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_2, [_createElementVNode("p", _hoisted_3, [_createElementVNode("span", null, _toDisplayString(Number(_ctx.inputContent).toFixed(2)), 1)]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("p", {
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return _ctx.clearInput();
        })
      }, "C"), _createElementVNode("p", {
        onClick: _cache[1] || (_cache[1] = //@ts-ignore
        function () {
          return _ctx.updateInput && _ctx.updateInput.apply(_ctx, arguments);
        })
      }, _toDisplayString(_ctx.decimal), 1), _createElementVNode("p", {
        onClick: _cache[2] || (_cache[2] = function ($event) {
          return _ctx.eraseFromInput();
        })
      }, "DEL")]), _createElementVNode("div", _hoisted_6, [_createElementVNode("p", {
        onClick: _cache[3] || (_cache[3] = //@ts-ignore
        function () {
          return _ctx.updateInput && _ctx.updateInput.apply(_ctx, arguments);
        })
      }, "7"), _createElementVNode("p", {
        onClick: _cache[4] || (_cache[4] = //@ts-ignore
        function () {
          return _ctx.updateInput && _ctx.updateInput.apply(_ctx, arguments);
        })
      }, "8"), _createElementVNode("p", {
        onClick: _cache[5] || (_cache[5] = //@ts-ignore
        function () {
          return _ctx.updateInput && _ctx.updateInput.apply(_ctx, arguments);
        })
      }, "9")]), _createElementVNode("div", _hoisted_7, [_createElementVNode("p", {
        onClick: _cache[6] || (_cache[6] = //@ts-ignore
        function () {
          return _ctx.updateInput && _ctx.updateInput.apply(_ctx, arguments);
        })
      }, "4"), _createElementVNode("p", {
        onClick: _cache[7] || (_cache[7] = //@ts-ignore
        function () {
          return _ctx.updateInput && _ctx.updateInput.apply(_ctx, arguments);
        })
      }, "5"), _createElementVNode("p", {
        onClick: _cache[8] || (_cache[8] = //@ts-ignore
        function () {
          return _ctx.updateInput && _ctx.updateInput.apply(_ctx, arguments);
        })
      }, "6")]), _createElementVNode("div", _hoisted_8, [_createElementVNode("p", {
        onClick: _cache[9] || (_cache[9] = //@ts-ignore
        function () {
          return _ctx.updateInput && _ctx.updateInput.apply(_ctx, arguments);
        })
      }, "1"), _createElementVNode("p", {
        onClick: _cache[10] || (_cache[10] = //@ts-ignore
        function () {
          return _ctx.updateInput && _ctx.updateInput.apply(_ctx, arguments);
        })
      }, "2"), _createElementVNode("p", {
        onClick: _cache[11] || (_cache[11] = //@ts-ignore
        function () {
          return _ctx.updateInput && _ctx.updateInput.apply(_ctx, arguments);
        })
      }, "3")]), _createElementVNode("div", _hoisted_9, [_createElementVNode("p", {
        onClick: _cache[12] || (_cache[12] = //@ts-ignore
        function () {
          return _ctx.updateInput && _ctx.updateInput.apply(_ctx, arguments);
        })
      }, "00"), _createElementVNode("p", {
        onClick: _cache[13] || (_cache[13] = //@ts-ignore
        function () {
          return _ctx.updateInput && _ctx.updateInput.apply(_ctx, arguments);
        })
      }, "0"), _hoisted_10])])])];
    }),
    _: 1
  }, 8, ["modelValue"])]);
}